import htmlparser from "htmlparser2";

// SUCCESSFUL RESPONSE

//  <Profile>
//    <Matches>9</Matches>
//    <Errors />
//    <Mortgagees>
//      <Mortgagee>
//        <DataItem name="Name" value="Cendant Mortgage" />
//        <DataItem name="AddressLine1" value="3000 Leaden Hall Rd" />
//        <DataItem name="AddressLine2" value="" />
//        <DataItem name="City" value="Mount Laurel" />
//        <DataItem name="State" value="NJ" />
//        <DataItem name="ZipCode" value="08054" />
//        <DataItem name="Index" value="58" />
//      </Mortgagee>
//      [...]
//    </Mortgagees>
//  </Profile>;

// ERROR RESPONSE

// <Profile>
//   <Matches>72</Matches>
//   <Errors>
//     <Error>There are 72 matches but a maximum of 30 matches requested.</Error>
//   </Errors>
//   <Mortgagees />
// </Profile>

export default profilerResponse => {
  const mortgagees = [];
  let mortgagee = null;
  let error = "";
  let expectError = false;
  let matches = 0;
  let expectMatches = false;
  new htmlparser.Parser(
    {
      onopentag: (name, props) => {
        if (name === "Mortgagee") {
          mortgagee = {};
        } else if (name === "DataItem") {
          mortgagee[props.name] = props.value;
        } else if (name === "Error") {
          expectError = true;
        } else if (name === "Matches") {
          expectMatches = true;
        }
      },
      ontext: text => {
        if (expectError) {
          error = text;
          expectError = false;
        }
        if (expectMatches) {
          matches = parseInt(text, 10);
          expectMatches = false;
        }
      },
      onclosetag: name => {
        if (name === "Mortgagee") {
          mortgagees.push(mortgagee);
          mortgagee = null;
        }
      }
    },
    { xmlMode: true, decodeEntities: true }
  ).end(profilerResponse);

  return { mortgagees, error, matches };
};
